import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../features/authSlice";
import { useContext, useEffect, useState } from "react";
import { NotificationAlertContext } from "../app/NotificationAlertContext";

const Sidebar = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { notificationAlert } = useContext(NotificationAlertContext);
  const [isShaking, setIsShaking] = useState(false);

  useEffect(() => {
    let shakeTimeout;
    let shakeInterval;
    if (notificationAlert) {
      const doShake = () => {
        setIsShaking(true);
        shakeTimeout = setTimeout(() => setIsShaking(false), 600); // shake duration
      };
      doShake(); // initial shake
      shakeInterval = setInterval(doShake, 5000);
    } else {
      setIsShaking(false);
    }
    return () => {
      clearTimeout(shakeTimeout);
      clearInterval(shakeInterval);
    };
  }, [notificationAlert]);

  const isHomePageActive = location.pathname === "/active-hubs";

  const isDriversActive =
    location.pathname === "/manage-drivers" ||
    location.pathname.includes("/manage-drivers/") ||
    location.pathname === "/drivers" ||
    location.pathname.includes("/drivers/") ||
    location.pathname.includes("/history/drivers/") ||
    location.pathname.includes("/allocate-new-driver");

  const isOutletsActive =
    location.pathname === "/manage-outlets" ||
    location.pathname.includes("/manage-outlets/") ||
    location.pathname === "/outlets" ||
    location.pathname.includes("/outlets/") ||
    location.pathname.includes("/history/outlets/");

  const isAdminActive = location.pathname === "/add-admin";

  const handleLogout = () => {
    dispatch(logout());
    window.location.reload();
  };

  return (
    <div className="fixed left-0 top-0 w-[14.5vw] h-screen shadow-custom2 rounded-r-2xl bg-white">
      <div className="p-6 flex">
        <Link to="/">
          <img src="/assets/logo.svg" alt="beep_ Logo" className="w-24" />
        </Link>
      </div>
      <div className="h-[88.5%] flex flex-col justify-between pb-8">
        <ul className="flex flex-col gap-3 pt-5">
          <li>
            <NavLink
              to="/"
              className={({ isActive }) =>
                isActive || isHomePageActive
                  ? "flex items-center gap-3 bg-quaternary text-white font-semibold 2xl:text-sm xl:text-[13px] lg:text-xs tracking-wider pl-6 py-2 rounded-r-full shadow-custom3 w-[97%]"
                  : "flex items-center gap-3 text-[#A7A7A7] font-semibold 2xl:text-sm xl:text-[13px] lg:text-xs tracking-wider pl-6 py-2 rounded-r-full shadow-custom3 w-[97%]"
              }
            >
              {({ isActive }) => (
                <>
                  <img
                    src="/assets/home.svg"
                    alt=""
                    className={
                      isActive || isHomePageActive
                        ? "h-[18px] filter invert brightness-0"
                        : "h-[18px]"
                    }
                  />
                  Home
                </>
              )}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/outlets"
              className={({ isActive }) =>
                isActive || isOutletsActive
                  ? "flex items-center gap-3 bg-quaternary text-white font-semibold 2xl:text-sm xl:text-[13px] lg:text-xs tracking-wider pl-6 py-2 rounded-r-full shadow-custom3 w-[97%]"
                  : "flex items-center gap-3 text-[#A7A7A7] font-semibold 2xl:text-sm xl:text-[13px] lg:text-xs tracking-wider pl-6 py-2 rounded-r-full shadow-custom3 w-[97%]"
              }
            >
              {({ isActive }) => (
                <>
                  <img
                    src="/assets/outlet.svg"
                    alt=""
                    className={
                      isActive || isOutletsActive
                        ? "h-[18px] filter invert brightness-0"
                        : "h-[18px]"
                    }
                  />
                  Outlets
                </>
              )}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/drivers"
              className={({ isActive }) =>
                isActive || isDriversActive
                  ? "flex items-center gap-3 bg-quaternary text-white font-semibold 2xl:text-sm xl:text-[13px] lg:text-xs tracking-wider pl-6 py-2 rounded-r-full shadow-custom3 w-[97%]"
                  : "flex items-center gap-3 text-[#A7A7A7] font-semibold 2xl:text-sm xl:text-[13px] lg:text-xs tracking-wider pl-6 py-2 rounded-r-full shadow-custom3 w-[97%]"
              }
            >
              {({ isActive }) => (
                <>
                  <img
                    src="/assets/drivers.svg"
                    alt=""
                    className={
                      isActive || isDriversActive
                        ? "h-[18px] filter invert brightness-0"
                        : "h-[18px]"
                    }
                  />
                  Drivers
                </>
              )}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/orders"
              className={({ isActive }) =>
                isActive
                  ? "flex items-center gap-3 bg-quaternary text-white font-semibold 2xl:text-sm xl:text-[13px] lg:text-xs tracking-wider pl-6 py-2 rounded-r-full shadow-custom3 w-[97%]"
                  : "flex items-center gap-3 text-[#A7A7A7] font-semibold 2xl:text-sm xl:text-[13px] lg:text-xs tracking-wider pl-6 py-2 rounded-r-full shadow-custom3 w-[97%]"
              }
            >
              {({ isActive }) => (
                <>
                  <img
                    src="/assets/payments.svg"
                    alt=""
                    className={
                      isActive
                        ? "h-[18px] filter invert brightness-0"
                        : "h-[18px]"
                    }
                  />
                  Orders
                </>
              )}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/manage-admin"
              className={({ isActive }) =>
                isActive || isAdminActive
                  ? "flex items-center gap-3 bg-quaternary text-white font-semibold 2xl:text-sm xl:text-[13px] lg:text-xs tracking-wider pl-6 py-2 rounded-r-full shadow-custom3 w-[97%]"
                  : "flex items-center gap-3 text-[#A7A7A7] font-semibold 2xl:text-sm xl:text-[13px] lg:text-xs tracking-wider pl-6 py-2 rounded-r-full shadow-custom3 w-[97%]"
              }
            >
              {({ isActive }) => (
                <>
                  <img
                    src="/assets/add-admin.svg"
                    alt=""
                    className={
                      isActive || isAdminActive
                        ? "h-[18px] filter invert brightness-0"
                        : "h-[18px]"
                    }
                  />
                  Manage admin
                </>
              )}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/pricing"
              className={({ isActive }) =>
                isActive
                  ? "flex items-center gap-3 bg-quaternary text-white font-semibold 2xl:text-sm xl:text-[13px] lg:text-xs tracking-wider pl-6 py-2 rounded-r-full shadow-custom3 w-[97%]"
                  : "flex items-center gap-3 text-[#A7A7A7] font-semibold 2xl:text-sm xl:text-[13px] lg:text-xs tracking-wider pl-6 py-2 rounded-r-full shadow-custom3 w-[97%]"
              }
            >
              {({ isActive }) => (
                <>
                  <img
                    src="/assets/pricing.svg"
                    alt=""
                    className={
                      isActive
                        ? "h-[18px] filter invert brightness-0"
                        : "h-[18px]"
                    }
                  />
                  Pricing
                </>
              )}
            </NavLink>
          </li>
        </ul>

        <ul className="flex flex-col gap-3 pt-5">
          <li>
            <NavLink
              to="/profile"
              className={({ isActive }) =>
                isActive
                  ? "flex items-center gap-3 bg-quaternary text-white font-semibold 2xl:text-sm xl:text-[13px] lg:text-xs tracking-wider pl-6 py-2 rounded-r-full shadow-custom3 w-[97%]"
                  : "flex items-center gap-3 text-[#A7A7A7] font-semibold 2xl:text-sm xl:text-[13px] lg:text-xs tracking-wider pl-6 py-2 rounded-r-full shadow-custom3 w-[97%]"
              }
            >
              {({ isActive }) => (
                <>
                  <img
                    src="/assets/profile.svg"
                    alt=""
                    className={
                      isActive
                        ? "h-[18px] filter invert brightness-0"
                        : "h-[18px]"
                    }
                  />
                  Profile
                </>
              )}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/notifications"
              className={({ isActive }) =>
                `${
                  isActive
                    ? "flex items-center gap-3 bg-quaternary text-white font-semibold 2xl:text-sm xl:text-[13px] lg:text-xs tracking-wider pl-6 py-2 rounded-r-full shadow-custom3 w-[97%]"
                    : "flex items-center gap-3 text-[#A7A7A7] font-semibold 2xl:text-sm xl:text-[13px] lg:text-xs tracking-wider pl-6 py-2 rounded-r-full shadow-custom3 w-[97%]"
                } ${notificationAlert && isShaking ? "animate-shake" : ""}`
              }
            >
              {({ isActive }) => (
                <>
                  <span className="relative inline-block">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      className={isActive ? "filter invert brightness-0" : ""}
                      style={{ minWidth: 18 }}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"
                      />
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M13.73 21a2 2 0 0 1-3.46 0"
                      />
                    </svg>
                    {notificationAlert && (
                      <span className="absolute -top-1 -right-1 w-3 h-3 bg-[#F75E00] rounded-full border-2 border-white animate-pulse z-10"></span>
                    )}
                  </span>
                  Notifications
                </>
              )}
            </NavLink>
          </li>

          <li>
            <div
              className="flex items-center gap-3 text-[#A7A7A7] font-semibold 2xl:text-sm xl:text-[13px] lg:text-xs tracking-wider pl-6 py-2 rounded-r-full shadow-custom3 w-[97%] cursor-pointer"
              onClick={handleLogout}
            >
              <img src="/assets/logout.svg" alt="" className={"h-[18px]"} />
              Logout
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
